import { Component, OnInit, Input } from '@angular/core';
import { Shared } from '../shared.service';
import * as _ from "lodash";

@Component({
  selector: 'product-item',
  templateUrl: './product-item.component.html',
  styleUrls: ['./product-item.component.scss']
})
export class ProductItemComponent implements OnInit {

  @Input() product;
  product_copy;
  hasProduct;
  active = false;

  constructor(public shared: Shared) { }

  ngOnInit() {
      this.hasProduct = true;
      this.product_copy = _.cloneDeep(this.product);
  }

  deleteChanges(){
      this.product_copy = _.cloneDeep(this.product);
  }

  inMenu(){
      if(this.hasProduct){
          return this.product.locations[this.shared.firebase_user.location];
      }
      return false;
  }

  toggleActive(){
      this.active = !this.active;
  }

  addToMenu(){
    let payload = {locations: {...this.product.locations}};
    payload.locations[this.shared.firebase_user['location']] = true;
    this.shared.productsRef.update(this.product.$key, payload);
  }

  removeFromMenu(){
    let payload = {locations: {...this.product.locations}};
    payload.locations[this.shared.firebase_user['location']] = false;
    this.shared.productsRef.update(this.product.$key, payload);
  }

}



// WEBPACK FOOTER //
// ./src/app/product-item/product-item.component.ts